'use strict';

require('./cn-distribution-box.scss');

module.exports = {
  template: require('./cn-distribution-box.html'),
  controller: require('./cn-distribution-box.controller.js'),
  controllerAs: 'vm',

  bindings: {
    managerPoints: '<',
    employeePoints: '<',
    performancePoints: '<',
    maxPoints: '<',
    managerClass: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-distribution-box/index.js
 ** module id = 56
 ** module chunks = 0
 **/